import React, { useEffect, useState, useContext, useMemo } from "react";
import { Typography, Box, Backdrop, CircularProgress, TextField, MenuItem, Button, Stack} from "@mui/material";
import Header from "../Components/layout/Header";
import { API } from "../conf";
import { Context } from "../App";

export default function Rapport() {
    const { updateConnect, exercice } = useContext(Context)
    const [organisation, setOrganisation] = useState(JSON.parse(sessionStorage.getItem('eglise')))
    const [agent, setAgent] = useState(JSON.parse(sessionStorage.getItem('user')))
    const [eglises, setEglises] = useState([])
    const [egliseId, setEgliseId] = useState('')
    const [loading, setLoad] = useState(true)
    const [months, setMonths] = useState([])
    const [clotures, setClotures] = useState([])
    const [month, setMonth] = useState('')
    const [pdf, setPdf] = useState()
    
    const eglise = useMemo(()=>organisation&&organisation.type==='église' ? organisation : eglises.find(el=>el._id===egliseId), [egliseId, eglises, organisation])

    function getRapport(month_index) {
        setPdf()
        const cloture = clotures.find(cloture => new Date(cloture.date).getMonth() === month_index)
        if(eglise?._id && cloture){    
            setLoad(true)
            fetch(API.concat(`/eglises/${eglise._id}/rapport/${cloture._id}`), {
                method:'GET',
                headers: {
                    Accept: 'application/pdf',
                    'Content-Type': 'application/pdf',
                    'Authorization': 'Bearer ' + sessionStorage.getItem('token')
                }
            }).then(async response=>{
                const token = response.headers.get('x-auth-token')
                if(response.status === 401) {
                    sessionStorage.clear()
                    updateConnect(false)
                }else {
                    if (token && token !== sessionStorage.getItem('token') && token !== '') {
                        sessionStorage.setItem('token', response.headers.get('x-auth-token'))
                    }
                    if (response.status === 200) {
                        const blob = await response.blob()
                        setPdf(URL.createObjectURL(blob))
                    }
                    setLoad(false)
                }
            })
        }
    }

    function handleReeditRapport() {
        setPdf()
        const cloture = clotures.find(cloture => new Date(cloture.date).getMonth() === month)
        if(eglise?._id && cloture){    
            setLoad(true)
            fetch(API.concat(`/eglises/${eglise._id}/rapport/${cloture._id}/reedit`), {
                method:'GET',
                headers: {
                    Accept: 'application/pdf',
                    'Content-Type': 'application/pdf',
                    'Authorization': 'Bearer ' + sessionStorage.getItem('token')
                }
            }).then(async response=>{
                const token = response.headers.get('x-auth-token')
                if(response.status === 401) {
                    sessionStorage.clear()
                    updateConnect(false)
                }else {
                    if (token && token !== sessionStorage.getItem('token') && token !== '') {
                        sessionStorage.setItem('token', response.headers.get('x-auth-token'))
                    }
                    if (response.status === 200) {
                        const blob = await response.blob()
                        setPdf(URL.createObjectURL(blob))
                    }
                    setLoad(false)
                }
            })
        }
    }

    function handleEditPreRapport() {
        setPdf()
        if(eglise?._id){    
            setLoad(true); 
            fetch(API.concat(`/eglises/${eglise._id}/pre_rapport?month=${month+1}&exercice=${exercice}`), {
                method:'GET',
                headers: {
                    Accept: 'application/pdf',
                    'Content-Type': 'application/pdf',
                    'Authorization': 'Bearer ' + sessionStorage.getItem('token')
                }
            }).then(async response=>{
                const token = response.headers.get('x-auth-token')
                if(response.status === 401) {
                    sessionStorage.clear()
                    updateConnect(false)
                }else {
                    if (token && token !== sessionStorage.getItem('token') && token !== '') {
                        sessionStorage.setItem('token', response.headers.get('x-auth-token'))
                    }
                    if (response.status === 200) {
                        const blob = await response.blob()
                        setPdf(URL.createObjectURL(blob))
                    }
                    setLoad(false)
                }
            })
        }
    }

    function reset() {
        setMonth('')
        setPdf()
    }  

    function getClotures() {
        setLoad(true)
        fetch(API.concat(`/eglises/${eglise.number}/cloture/years/${exercice}`), {
            method:'GET',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + sessionStorage.getItem('token')
            }
        }).then(async response=>{
            const token = response.headers.get('x-auth-token')
            if(response.status === 401) {
                sessionStorage.clear()
                updateConnect(false)
            }else {
                if (token && token !== sessionStorage.getItem('token') && token !== '') {
                    sessionStorage.setItem('token', response.headers.get('x-auth-token'))
                }
                if (response.status === 200) {
                    const json = await response.json()
                    const months = json.sort((a, b) => new Date(a.date).getMonth()-new Date(b.date).getMonth())
                    setClotures(months);
                    setLoad(false)
                }
            }
        })
    }

    useEffect(() => {
        if(eglise?._id) {
            getClotures()
        }
    }, [eglise])
    
    useEffect(()=>{
        if (organisation&&organisation.type==='fédération') {
            setLoad(true)
            fetch(API.concat(`/eglises/by/${JSON.stringify(agent.eglises?.length>0 ? {_id:{$in: agent.eglises}}:{type:'église'})}`), {
                method:'GET',
                headers:{
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + sessionStorage.getItem('token')
                }
            }).then(async(response) => {
                const token = response.headers.get('x-auth-token')
                if(response.status === 401) {
                    sessionStorage.clear()
                    updateConnect(false)
                }else {
                    if (token && token !== sessionStorage.getItem('token') && token !== '') {
                        sessionStorage.setItem('token', response.headers.get('x-auth-token'))
                    }
                    if (response.status === 200) {
                        const json = await response.json();
                        setEglises(json)
                        setLoad(false)
                    }
                }
            })
        }
    }, [organisation])

    useEffect(()=>{
        setOrganisation(JSON.parse(sessionStorage.getItem('eglise')))
        setAgent(JSON.parse(sessionStorage.getItem('user')))
        const currentMonth = new Date().getFullYear()>exercice ? 11 : new Date().getMonth()
        const monthsArray = new Array(currentMonth+1).fill().map((_, index) => index)
        setMonths(monthsArray)
    },[])
    
    return(
        <div style={{display:'flex', flexDirection:'column', height:'100vh'}}>
            <Header/>
            <Typography sx={{textAlign:'center', marginTop:'20px', fontSize:26}}>Rapport mensuel</Typography>
            
            {organisation&&organisation.type==='fédération'&&<TextField select size="small" label="église" sx={{alignSelf:'end',marginBottom:3, width:'25%', marginRight:3, minWidth:'200px'}} value={egliseId} onChange={e=>setEgliseId(old=>{if(old!==e.target.value)reset(); return e.target.value})}>
                {eglises.map(eglise=><MenuItem key={eglise._id} value={eglise._id}>{`${eglise.nom} - ${eglise.commune.toUpperCase()}`}</MenuItem>)}
            </TextField>}

            {eglise&&<Box sx={{paddingX:'20px', marginTop:'30px', display:'flex', flexDirection:'column', flex:1}}>
                
                <Stack direction='row' spacing={5} sx={{marginBottom:'25px', alignItems:'center'}}>
                    <TextField select required id="outlined-select-currency" label="Mois" size="small" value={month} sx={{minWidth:'300px'}}
                    slotProps={{select: {native: true}, inputLabel: {shrink: true}}}
                    onChange={(e)=> { setMonth(Number(e.target.value)); getRapport(Number(e.target.value)) }}>
                        <option value='' disabled>Sélectionner un mois</option>
                        {months.map((month, index) => (
                            <option key={index} value={month}>{new Date(0, month).toLocaleString('fr', {month:'long'})}</option>
                        ))}
                    </TextField>

                    {month !=='' && !clotures.some(cloture => new Date(cloture.date).getMonth() === month) && <Button variant="contained" onClick={handleEditPreRapport}>Générer un rapport temporaire</Button>}
                    {pdf && clotures.some(cloture => new Date(cloture.date).getMonth() === month) && <Button variant="contained" onClick={handleReeditRapport}>Rééditer</Button>}
                </Stack>
                
                {month !=='' && !loading && (pdf ? <embed src={pdf} width='100%' height='100%' type="application/pdf" style={{marginTop:20, minHeight:'800px'}} /> :
                clotures.some(cloture => new Date(cloture.date).getMonth() === month) &&
                <Typography textAlign='center'>Une erreur est survenue lors de la récupération du rapport, veuillez réessayer plus tard.<br/>Si le problème persiste veuillez contacter votre administrateur.</Typography>)}
            </Box>}

            <Backdrop open={loading}><CircularProgress color="inherit" /></Backdrop>
        </div>
    )
}